import * as types from './types';
import ViewHierarchy, {
    VIEW_HIERARCHY_SUB_BUNDLE_DETAIL,
    VIEW_HIERARCHY_SUB_BUNDLE_LIST,
    VIEW_HIERARCHY_SUB_BY_PRODUCT_TYPE,
    VIEW_HIERARCHY_SUB_CAMPAIGNS,
    VIEW_HIERARCHY_SUB_CART,
    VIEW_HIERARCHY_SUB_CATALOGUE,
    VIEW_HIERARCHY_SUB_CHECKOUT,
    VIEW_HIERARCHY_SUB_CHECKOUT_THANKS,
    VIEW_HIERARCHY_SUB_COLLECTION_BY_GENRE,
    VIEW_HIERARCHY_SUB_COLLECTION_NEWLY_ADDED,
    VIEW_HIERARCHY_SUB_COLLECTION_SEARCH,
    VIEW_HIERARCHY_SUB_COMPLETE_COLLECTION,
    VIEW_HIERARCHY_SUB_FOREIGN_LANGUAGE_BUNDLES,
    VIEW_HIERARCHY_SUB_INCOMPLETE_SERIES,
    VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING,
    VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_FEATUERD,
    VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_NEWLY_ADDED,
    VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_PRODUCTS,
    VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUP,
    VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUPS,
    VIEW_HIERARCHY_SUB_LIBX_ALL_TITLES,
    VIEW_HIERARCHY_SUB_LIBX_FEATURED,
    VIEW_HIERARCHY_SUB_LIBX_GENRES,
    VIEW_HIERARCHY_SUB_LIBX_LOCAL_REGIONS,
    VIEW_HIERARCHY_SUB_LIBX_NEWLY_ADDED,
    VIEW_HIERARCHY_SUB_LIBX_PRODUCT_DETAIL,
    VIEW_HIERARCHY_SUB_LOCAL_CONTENT_AUTHORS,
    VIEW_HIERARCHY_SUB_LOCAL_CONTENT_COLLECTION,
    VIEW_HIERARCHY_SUB_LOCAL_CONTENT_PRODUCT_DETAILS,
    VIEW_HIERARCHY_SUB_LOCAL_CONTENT_PRODUCTS,
    VIEW_HIERARCHY_SUB_LOTE,
    VIEW_HIERARCHY_SUB_LOTE_FEATUERD,
    VIEW_HIERARCHY_SUB_LOTE_GENRES,
    VIEW_HIERARCHY_SUB_LOTE_NEWLY_ADDED,
    VIEW_HIERARCHY_SUB_LOTE_PRODUCTS,
    VIEW_HIERARCHY_SUB_MARKETING_CAMPAIGNS,
    VIEW_HIERARCHY_SUB_ORDER_ASSISTANT,
    VIEW_HIERARCHY_SUB_ORDERS,
    VIEW_HIERARCHY_SUB_ORDERS_DETAIL,
    VIEW_HIERARCHY_SUB_PRODUCT_DETAIL,
    VIEW_HIERARCHY_SUB_RESERVE_CHECKOUT,
    VIEW_HIERARCHY_SUB_RESERVE_DETAIL,
    VIEW_HIERARCHY_SUB_RESERVE_LIST,
    VIEW_HIERARCHY_SUB_SEARCH,
    VIEW_HIERARCHY_SUB_SELECTIONLIST,
    VIEW_HIERARCHY_SUB_TERMS_AND_CONDITIONS
} from '../../shared/utils/utils-viewhierarchy';
import { HeaderState } from './state';
import { HeaderAction } from './types';

const initialHeaderState = {
    firstHeaderReload: true,
    viewHierarchy: [] as string[]
} as HeaderState;

export function headerReducer(headerState: HeaderState = initialHeaderState, action: HeaderAction): HeaderState {
    let newViewHierarchy = [];

    const shopRoute = route => ViewHierarchy.pushShopRoute(headerState.viewHierarchy, route);
    const orderingAssistantRoute = route => ViewHierarchy.pushOrderAssistantRoute(route);
    const localContentRoute = route => ViewHierarchy.pushLocalContentRoute(route);
    const yourCollectionRoute = route => ViewHierarchy.pushYourCollectionRoute(route);
    const bundleRoute = route => ViewHierarchy.pushBundleRoute(route);
    const libxRoute = route => ViewHierarchy.pushLibxRoute(route);
    const foreignLanguageRoute = route => ViewHierarchy.pushForeignLanguageRoute(route);
    const loteRoute = route => ViewHierarchy.pushLoteRoute(route);
    const languageLearningRoute = route => ViewHierarchy.pushLanguageLearningRoute(route);
    const campaignsRoute = route => ViewHierarchy.pushCampaignsRoute(route);
    const marketingRoute = route => ViewHierarchy.pushMarketingRoute(route);

    switch (action.type) {
        case types.RELOAD_HEADER:
            return {
                ...headerState,
                reload: true
            };

        case types.RELOAD_HEADER_SUCCESS:
            return {
                ...headerState,
                reload: false,
                firstHeaderReload: false
            };

        case types.SET_STICKY_MODE:
            return {
                ...headerState,
                isSticky: action.payload
            };

        case types.ACTIVE_VIEW_CHECKOUT:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_CHECKOUT);
            return { ...headerState, viewHierarchy: newViewHierarchy };

        case types.ACTIVE_VIEW_RESERVE_CHECKOUT:
            newViewHierarchy = orderingAssistantRoute(VIEW_HIERARCHY_SUB_RESERVE_CHECKOUT);
            return { ...headerState, viewHierarchy: newViewHierarchy };

        case types.ACTIVE_VIEW_RESERVE_LIST:
            newViewHierarchy = orderingAssistantRoute(VIEW_HIERARCHY_SUB_RESERVE_LIST);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_CATALOGUE:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_CATALOGUE);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_BY_PRODUCT_TYPE:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_BY_PRODUCT_TYPE);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_SELECTIONLIST:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_SELECTIONLIST);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_CART:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_CART);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_CHECKOUT_THANKS:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_CHECKOUT_THANKS);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_ORDERS:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_ORDERS);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_ORDERS_DETAIL:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_ORDERS_DETAIL);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_SEARCH:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_SEARCH);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_PRODUCT_DETAIL:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_PRODUCT_DETAIL);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_BUNDLE_DETAIL:
            newViewHierarchy = bundleRoute(VIEW_HIERARCHY_SUB_BUNDLE_DETAIL);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_BUNDLE_LIST:
            newViewHierarchy = bundleRoute(VIEW_HIERARCHY_SUB_BUNDLE_LIST);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_ORDER_ASSISTANT:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_ORDER_ASSISTANT);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_INCOMPLETE_SERIES:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_INCOMPLETE_SERIES);
            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_RESERVE_DETAIL:
            newViewHierarchy = orderingAssistantRoute(VIEW_HIERARCHY_SUB_RESERVE_DETAIL);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_COMPLETE_COLLECTION:
            newViewHierarchy = yourCollectionRoute(VIEW_HIERARCHY_SUB_COMPLETE_COLLECTION);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_NEWLY_ADDED:
            newViewHierarchy = yourCollectionRoute(VIEW_HIERARCHY_SUB_COLLECTION_NEWLY_ADDED);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_BY_GENRE:
            newViewHierarchy = yourCollectionRoute(VIEW_HIERARCHY_SUB_COLLECTION_BY_GENRE);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_COLLECTION_SEARCH:
            newViewHierarchy = yourCollectionRoute(VIEW_HIERARCHY_SUB_COLLECTION_SEARCH);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_LOCAL_CONTENT_COLLECTION:
            newViewHierarchy = localContentRoute(VIEW_HIERARCHY_SUB_LOCAL_CONTENT_COLLECTION);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_LOCAL_CONTENT_PRODUCTS:
            newViewHierarchy = localContentRoute(VIEW_HIERARCHY_SUB_LOCAL_CONTENT_PRODUCTS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_LOCAL_CONTENT_PRODUCT_DETAILS:
            newViewHierarchy = localContentRoute(VIEW_HIERARCHY_SUB_LOCAL_CONTENT_PRODUCT_DETAILS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_LOCAL_CONTENT_AUTHORS:
            newViewHierarchy = localContentRoute(VIEW_HIERARCHY_SUB_LOCAL_CONTENT_AUTHORS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_LIBX_PRODUCT_DETAIL:
            newViewHierarchy = libxRoute(VIEW_HIERARCHY_SUB_LIBX_PRODUCT_DETAIL);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_TERMS_AND_CONDITIONS:
            newViewHierarchy = shopRoute(VIEW_HIERARCHY_SUB_TERMS_AND_CONDITIONS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };

        case types.ACTIVE_VIEW_LIBX_FEATURED:
            newViewHierarchy = libxRoute(VIEW_HIERARCHY_SUB_LIBX_FEATURED);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LIBX_NEWLY_ADDED:
            newViewHierarchy = libxRoute(VIEW_HIERARCHY_SUB_LIBX_NEWLY_ADDED);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LIBX_ALL_TITLES:
            newViewHierarchy = libxRoute(VIEW_HIERARCHY_SUB_LIBX_ALL_TITLES);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LIBX_GENRES:
            newViewHierarchy = libxRoute(VIEW_HIERARCHY_SUB_LIBX_GENRES);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LIBX_REGIONS:
            newViewHierarchy = libxRoute(VIEW_HIERARCHY_SUB_LIBX_LOCAL_REGIONS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LOTE:
            newViewHierarchy = foreignLanguageRoute(VIEW_HIERARCHY_SUB_LOTE);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LOTE_FEATURED:
            newViewHierarchy = loteRoute(VIEW_HIERARCHY_SUB_LOTE_FEATUERD);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LOTE_NEWLYADDED:
            newViewHierarchy = loteRoute(VIEW_HIERARCHY_SUB_LOTE_NEWLY_ADDED);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LOTE_GENRES:
            newViewHierarchy = loteRoute(VIEW_HIERARCHY_SUB_LOTE_GENRES);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LOTE_PRODUCTS:
            newViewHierarchy = loteRoute(VIEW_HIERARCHY_SUB_LOTE_PRODUCTS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LANGUAGELEARNING:
            newViewHierarchy = foreignLanguageRoute(VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LANGUAGELEARNING_FEATURED:
            newViewHierarchy = languageLearningRoute(VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_FEATUERD);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LANGUAGELEARNING_NEWLYADDED:
            newViewHierarchy = languageLearningRoute(VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_NEWLY_ADDED);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LANGUAGELEARNING_PRODUCTS:
            newViewHierarchy = languageLearningRoute(VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_PRODUCTS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_FOREIGNLANGUAGE_BUNDLES:
            newViewHierarchy = foreignLanguageRoute(VIEW_HIERARCHY_SUB_FOREIGN_LANGUAGE_BUNDLES);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_CAMPAIGNS:
            newViewHierarchy = campaignsRoute(VIEW_HIERARCHY_SUB_CAMPAIGNS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUPS:
            newViewHierarchy = marketingRoute(VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUPS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUP:
            newViewHierarchy = marketingRoute(VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUP);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        case types.ACTIVE_VIEW_MARKETING_CAMPAIGNS:
            newViewHierarchy = marketingRoute(VIEW_HIERARCHY_SUB_MARKETING_CAMPAIGNS);

            return {
                ...headerState,
                viewHierarchy: newViewHierarchy
            };
        default:
            return headerState;
    }
}
